import gql from 'graphql-tag';
import { IItemWithString } from 'lib/type/common';
import getGraphQLClient from '../../GraphQL/graphQLClient';

//TODO: rootItemId and template should be read from sitecore contect data
export const GLOBAL_EMAIL_DOMAINS_FOLDER_ID = '{42A51EAA-CD53-4845-8BC2-1B866606E3B3}';
export const EMAIL_DOMAIN_ITEM_TEMPLATE_ID = '{498C2313-92DB-4ABF-A420-E9097428B1D6}';
const MAX_EMAIL_DOMAIN_PAGINATION_ITERATIONS = 100;

const GlobalEmailDomainsQuery = gql`
  query GlobalEmailDomainsForContactInfo(
    $rootItemId: String!
    $templateId: String!
    $language: String!
    $after: String!
  ) {
    search(
      where: {
        AND: [
          { name: "_path", value: $rootItemId, operator: CONTAINS }
          { name: "_templates", value: $templateId, operator: CONTAINS }
          { name: "_language", value: $language }
        ]
      }
      first: 50
      after: $after
    ) {
      pageInfo {
        endCursor
        hasNext
      }
      results {
        id
        name
        domainName: field(name: "name") {
          ... on TextField {
            value
          }
        }
      }
    }
  }
`;

function mapSearchRowsToEmailDomainItems(rows: any): IItemWithString[] {
  if (!Array.isArray(rows)) return [];
  return rows
    .map((row: any) => {
      const domain = String(row?.domainName?.value ?? row?.name ?? '').trim();
      if (!domain || !row?.id) return null;
      const display = String(row.name ?? domain);
      return {
        id: row.id,
        url: '',
        name: display,
        displayName: display,
        fields: { name: { value: domain } },
      } as IItemWithString;
    })
    .filter((x): x is IItemWithString => x != null);
}

export const getAllGlobalEmailDomainsForContactInfo = async (
  language: string
): Promise<IItemWithString[]> => {
  const rootItemId = (GLOBAL_EMAIL_DOMAINS_FOLDER_ID || '').trim();
  if (!rootItemId) {
    return [];
  }
  let emailDomainList: IItemWithString[] = [];
  let shouldQueryMoreItems = true;
  let after = '';
  let iteration = 0;

  while (shouldQueryMoreItems && iteration < MAX_EMAIL_DOMAIN_PAGINATION_ITERATIONS) {
    iteration += 1;
    const graphQLClient = getGraphQLClient();
    const fetchResponse = await graphQLClient.request<any>(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      GlobalEmailDomainsQuery as any,
      {
        rootItemId,
        templateId: EMAIL_DOMAIN_ITEM_TEMPLATE_ID,
        language,
        after,
      }
    );
    const batch = mapSearchRowsToEmailDomainItems(fetchResponse?.search?.results);
    emailDomainList = emailDomainList.concat(batch);
    const hasNext = fetchResponse?.search?.pageInfo?.hasNext ?? false;
    const endCursor = fetchResponse?.search?.pageInfo?.endCursor ?? '';
    shouldQueryMoreItems = hasNext && !!endCursor && endCursor !== after;
    after = endCursor;
  }

  return emailDomainList;
};

export const getContactEmailDomainsListForContactInfo = async (
  language: string,
  siteSettings: any
): Promise<IItemWithString[]> => {
  const fromLayout = siteSettings?.contactEmailDomains;
  if (Array.isArray(fromLayout) && fromLayout.length > 0) {
    return fromLayout as IItemWithString[];
  }
  return getAllGlobalEmailDomainsForContactInfo(language);
};

export default GlobalEmailDomainsQuery;
